import Vue from 'vue';
import App from './App.vue';
import router from './components/router/routes';
import axios from "axios";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Print from 'vue-print-nb';
import moment from "moment";
moment.locale('zh-cn');
import * as echarts from 'echarts';
import vueEsign from 'vue-esign'

Vue.use(ElementUI);
Vue.use(Print);
Vue.use(vueEsign)
Vue.prototype.$moment = moment;
Vue.prototype.$axios = axios;
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false;

new Vue({
    router,
    render: h => h(App),
}).$mount('#app')
